import React, { useEffect } from 'react';
import AOS from 'aos';
import Header from './Header';
import PageIllustration from './PageIllustration';
import Hero from './Hero';
import ScrollingSVG from './ScrollingSVG';
import Workflows from './Workflows';
import Features from './Features';
import Testimonials from './Testimonials';
import CTA from './CTA';
import Footer from './Footer';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 600,
      easing: 'ease-out-sine',
    });
  }, []);

  return (
    <div className="landing-page">
      <Header />
      <main className="landing-main">
        <PageIllustration multiple />
        <Hero />
        <ScrollingSVG 
          src="/lenet.svg" 
          alt="LeNet Architecture" 
          position="left"
          verticalOffset={-7}
        />
        <Workflows />
        <ScrollingSVG 
          src="/alexnet.svg" 
          alt="AlexNet Architecture" 
          position="right"
          verticalOffset={-7}
        />
        <Features />
        <ScrollingSVG 
          src="/gans.svg" 
          alt="GANs Architecture" 
          position="left"
        />
        <Testimonials />
        <ScrollingSVG 
          src="/transformer.svg" 
          alt="Transformer Architecture" 
          position="right"
        />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;

